import { ProgramListItem } from 'elements/eventView/atomic/ProgramListItem';
import { EColors2, EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    programIds: string[];
}

export const ProgramCard = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    const programs = props.programIds.map((programId) =>
        ctxEventView.allPrograms.find((e) => e.programId === programId)
    );

    if (!programs?.length) {
        return null;
    }

    return (
        <S_ProgramCard className={props.className}>
            <S_Title>{ctxEventView.programTitleShort}</S_Title>
            <S_Programs>
                {programs.map((program) => {
                    return (
                        <ProgramListItem
                            key={program.programId}
                            program={program}
                            dateStyle="datetime"
                        />
                    );
                })}
            </S_Programs>
        </S_ProgramCard>
    );
};

const S_ProgramCard = styled.div`
    display: flex;
    flex-direction: column;
    margin: 20px 0;
`;

const S_Title = styled.div`
    font-size: 18px;
    line-height: 20px;
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
    margin-bottom: 20px;
`;

const S_Programs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;
